<template>
  <div class="calibri" id="template">
    <div v-for="(item, index) in downloadRow" :key="item.id">
      <div v-if="item">
        <p class="text-center bold calibri text-secondary">{{
          item.company === 'NBL'
            ? 'NATURES BASKET LTD'
            : item.company === 'SRL'
            ? 'SPENCER’S RETAIL LIMITED'
            : item.company === 'CESC'
            ? 'CESC LIMITED'
            : ''
        }}</p>
        <p class="fs-small bold calibri text-center text-secondary">
          STATEMENT OF PHYSICAL VERIFICATION OF MAIN CASH, PETTY CASH AND FLOAT CASH AS ON {{ todayDate }}
        </p>
        <div class="d-flex justify-content-evenly">
          <p class="bold">STORE CODE: </p>
          <p class="ml-1">{{ item.storeid }}</p>
          <p class="ml-5 bold">STORE NAME: </p>
          <p class="ml-1">{{ item.storeName }}</p>
        </div>

        <div class="section mt-1" v-for="(mainItem, mainIndex) in item.mainCash" :key="mainIndex">
          <div v-if="mainItem">
            <div class="bold">MAIN CASH</div>
            <table>
              <tr>
                <th>DENOMINATION</th>
                <th>QUANTITY</th>
                <th>TOTAL AMOUNT (Rs)</th>
              </tr>
              <tr v-for="(mainDenomination, mainKey) in mainItem.denomination" :key="mainKey">
                <td>{{ mainDenomination ? mainDenomination.split(':::')[0] : '' }}₹</td>
                <td>{{ mainDenomination ? mainDenomination.split(':::')[1] : '' }}</td>
                <td
                  >₹{{
                    mainDenomination ? mainDenomination.split(':::')[0] * mainDenomination.split(':::')[1] : ''
                  }}</td
                >
              </tr>
              <tr class="total-row">
                <td></td>
                <td class="bold calibri">GRAND TOTAL</td>
                <td
                  >₹{{
                    mainItem.denomination &&
                    mainItem.denomination.reduce((total, item) => {
                      const [denomination, count] = item.split(':::').map(Number);
                      return total + denomination * count;
                    }, 0)
                  }}</td
                >
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Main Cash as per the DC1 report(Actual):</td>
                <td class="text-center">₹{{ mainItem.actualCash }}</td>
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Difference: </td>
                <td>₹{{ mainItem.difference }}</td>
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Remark:</td>
                <td>{{ mainItem.remarks }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="section mt-2" v-for="(onlineItem, onlineIndex) in item.onlineCash" :key="onlineIndex">
          <div v-if="onlineItem">
            <div class="bold">ONLINE CASH(IF APPLICABLE)</div>
            <table>
              <tr>
                <th>DENOMINATION</th>
                <th>QUANTITY</th>
                <th>TOTAL AMOUNT (Rs)</th>
              </tr>
              <tr v-for="(onlineDenomination, floatKey) in onlineItem.denomination" :key="floatKey">
                <td>{{ onlineDenomination ? onlineDenomination.split(':::')[0] : '' }}₹</td>
                <td>{{ onlineDenomination ? onlineDenomination.split(':::')[1] : '' }}</td>
                <td
                  >₹{{
                    onlineDenomination ? onlineDenomination.split(':::')[0] * onlineDenomination.split(':::')[1] : ''
                  }}</td
                >
              </tr>
              <tr class="total-row">
                <td></td>
                <td class="bold calibri">GRAND TOTAL</td>
                <td
                  >₹{{
                    onlineItem.denomination &&
                    onlineItem.denomination.reduce((total, item) => {
                      const [denomination, count] = item.split(':::').map(Number);
                      return total + denomination * count;
                    }, 0)
                  }}</td
                >
              </tr>
            </table>
          </div>
        </div>
        <div class="d-flex justify-content-end align-self-end">Page 1</div>
        <div v-if="item.company === 'SRL'">
          <div>
            <p class="text-center bold calibri text-secondary">{{
              item.company === 'NBL'
                ? 'NATURES BASKET LTD'
                : item.company === 'SRL'
                ? 'SPENCER’S RETAIL LIMITED'
                : item.company === 'CESC'
                ? 'CESC LIMITED'
                : ''
            }}</p>
            <p class="fs-small bold calibri text-center text-secondary">
              STATEMENT OF PHYSICAL VERIFICATION OF MAIN CASH, PETTY CASH AND FLOAT CASH AS ON {{ todayDate }}
            </p>
          </div>
          <div class="section mt-5" v-for="(floatItem, floatIndex) in item.floatCash" :key="floatIndex">
            <div class="bold">FLOAT CASH</div>
            <table>
              <tr>
                <th>DENOMINATION</th>
                <th>QUANTITY</th>
                <th>TOTAL AMOUNT (Rs)</th>
              </tr>
              <tr v-for="(floatDenomination, floatKey) in floatItem.denomination" :key="floatKey">
                <td>{{ floatDenomination ? floatDenomination.split(':::')[0] : '' }}₹</td>
                <td>{{ floatDenomination ? floatDenomination.split(':::')[1] : '' }}</td>
                <td
                  >₹{{
                    floatDenomination ? floatDenomination.split(':::')[0] * floatDenomination.split(':::')[1] : ''
                  }}</td
                >
              </tr>
              <tr class="total-row">
                <td></td>
                <td class="bold calibri">GRAND TOTAL</td>
                <td
                  >₹{{
                    floatItem.denomination &&
                    floatItem.denomination.reduce((total, item) => {
                      const [denomination, count] = item.split(':::').map(Number);
                      return total + denomination * count;
                    }, 0)
                  }}</td
                >
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Float Cash as per system:</td>
                <td class="text-center">₹{{ floatItem.actualCash }}</td>
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2"
                  >Difference (Difference in float cash is not allowed):
                </td>
                <td>₹{{ floatItem.difference }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="item.company === 'NBL'">
          <p class="text-center bold calibri text-secondary">{{
            item.company === 'NBL'
              ? 'NATURES BASKET LTD'
              : item.company === 'SRL'
              ? 'SPENCER’S RETAIL LIMITED'
              : item.company === 'CESC'
              ? 'CESC LIMITED'
              : ''
          }}</p>
          <p class="fs-small bold calibri text-center text-secondary">
            STATEMENT OF PHYSICAL VERIFICATION OF MAIN CASH, PETTY CASH AND FLOAT CASH AS ON {{ todayDate }}
          </p>
        </div>
        <div class="section mt-5" v-for="(pettyItem, pettyIndex) in item.pettyCash" :key="pettyIndex">
          <div v-if="pettyItem">
            <div class="bold">PETTY CASH</div>
            <table>
              <tr>
                <th>DENOMINATION</th>
                <th>QUANTITY</th>
                <th>TOTAL AMOUNT (Rs)</th>
              </tr>
              <tr v-for="(pettyDenomination, pettyKey) in pettyItem.denomination" :key="pettyKey">
                <td>{{ pettyDenomination ? pettyDenomination.split(':::')[0] : '' }}₹</td>
                <td>{{ pettyDenomination ? pettyDenomination.split(':::')[1] : '' }}</td>
                <td
                  >₹{{
                    pettyDenomination ? pettyDenomination.split(':::')[0] * pettyDenomination.split(':::')[1] : ''
                  }}</td
                >
              </tr>
              <tr class="total-row">
                <td></td>
                <td class="bold calibri">GRAND TOTAL</td>
                <td
                  >₹{{
                    pettyItem.denomination &&
                    pettyItem.denomination.reduce((total, item) => {
                      const [denomination, count] = item.split(':::').map(Number);
                      return total + denomination * count;
                    }, 0)
                  }}</td
                >
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Petty cash as per system:</td>
                <td class="text-center">₹{{ pettyItem.actualCash }}</td>
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Difference: </td>
                <td>₹{{ pettyItem.difference }}</td>
              </tr>
              <tr class="remark-section">
                <td class="text-left bold calibri" colspan="2">Remark:</td>
                <td>{{ pettyItem.remarks }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="mt-5 confirmed-by">
          <div class="bold">CONFIRMED BY</div>
          <table>
            <tr>
              <th>DESIGNATION</th>
              <th>NAME</th>
              <th>DATE & TIME</th>
            </tr>
            <tr>
              <td class="bold calibri">STORE MANAGER</td>
              <td>{{ storeManagerName }}</td>
              <td
                >{{ item.approvedBySmDateTime ? `${item.approvedBySmDateTime.split('T')[0]}/` : '' }}
                {{ item.approvedBySmDateTime ? item.approvedBySmDateTime.split('T')[1] : '' }}</td
              >
            </tr>
            <tr>
              <td class="bold calibri">TL/DM</td>
              <td>{{ item.tlDmName }}</td>
              <td
                >{{ item.approvedTimeOfTlDm ? `${item.approvedTimeOfTlDm.split('T')[0]}/` : '' }}
                {{ item.approvedTimeOfTlDm ? item.approvedTimeOfTlDm.split('T')[1] : '' }}</td
              >
            </tr>
          </table>
        </div>
        <div class="d-flex justify-content-end align-self-end">Page 2</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      downloadRow: {},
      todayDate: moment().format('DD-MM-YYYY'),
      storeManagerName: ''
    };
  }
};
</script>

<style scoped>
.calibri {
  font-family: Calibri(body);
}
.underline {
  text-decoration: underline;
}
.bold {
  font-weight: bold;
}
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
th,
td {
  border: 1px solid #000;
  padding: 4px;
  text-align: center;
}
th {
  background-color: #f2f2f2;
}
.total-row {
  font-weight: bold;
}
.confirmed-by table {
  width: auto;
  margin: 0 auto;
}
.fs-small {
  font-size: 12px;
}
</style>
